(() => {
  if (customElements.get('product-block-swatches')) return;

  class ProductBlockSwatches extends HTMLElement {
    constructor() {
      super();
      this.onSwatchClick = this.onSwatchClick.bind(this);
    }

    connectedCallback() {
      document.addEventListener('click', this.onSwatchClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onSwatchClick);
    }

    onSwatchClick(evt) {
      const link = evt.target.closest('.product-block__swatches-link');
      if (!link) return;

      evt.preventDefault();

      const item = link.closest('.product-block__swatches-item');
      if (item?.classList.contains('out-of-stock') || link.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const productUrl = link.getAttribute('data-product-url');
      if (!productUrl) return;

      const block = link.closest('.product-block');
      if (!block) return;

      const productLinks = block.querySelectorAll('.product-link');
      productLinks.forEach((el) => {
        el.setAttribute('href', productUrl);
        if (link.getAttribute('title')) {
          el.setAttribute('aria-label', link.getAttribute('title'));
        }
      });

      const swatchImages = block.querySelectorAll('.product-block__image--swatch');
      swatchImages.forEach((el) => {
        const isActive = el.getAttribute('data-product-url') === productUrl;
        el.classList.toggle('product-block__image--active', isActive);

        if (isActive) {
          el.querySelectorAll('.lazyload--manual').forEach((imgEl) => {
            imgEl.classList.remove('lazyload--manual');
            imgEl.classList.add('lazyload');
          });
        }
      });

      const items = block.querySelectorAll('.product-block__swatches-item');
      items.forEach((el) => el.classList.remove('current'));
      if (item) item.classList.add('current');
    }
  }

  customElements.define('product-block-swatches', ProductBlockSwatches);
})();
